// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ktmksrxhptasbdxcxzvm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt0bWtzcnhocHRhc2JkeGN4enZtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ5NDc2NDYsImV4cCI6MjA3MDUyMzY0Nn0.l3nNXEgvmTNam34FzZWK3ItOgbCvJF9xMUVfAOZfCiI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});